jQuery(document).ready(function ($) {
  $("#open-popup").click(function () {
    $("#popup-wrapper").slideDown();
    $("#popup-overlay").fadeIn();
  });

  $("#close-popup").click(function () {
    $("#popup-wrapper").slideUp();
    $("#popup-overlay").fadeOut();
  });

  $("#popup-overlay").click(function () {
    $("#popup-wrapper").slideUp();
    $("#popup-overlay").fadeOut();
  });
});

function menuOpening() {
  const menuOpener = document.getElementById("menuOpener");
  const menuOpening = document.getElementById("menuOpening");
  const menuCloser = document.getElementById("menuCloser");

  if (!menuOpener || !menuOpening || !menuCloser) return;

  menuOpener.addEventListener("click", () => {
    menuOpening.classList.replace(
      "[clip-path:polygon(100%_0%_,_100%_0%,_100%_100%,_100%_100%)]",
      "[clip-path:polygon(0%_0%_,_100%_0%,_100%_100%,_0%_100%)]"
    );
  });

  menuCloser.addEventListener("click", () => {
    menuOpening.classList.replace(
      "[clip-path:polygon(0%_0%_,_100%_0%,_100%_100%,_0%_100%)]",
      "[clip-path:polygon(100%_0%_,_100%_0%,_100%_100%,_100%_100%)]"
    );
  });
}
menuOpening();

function filterOpening() {
  const filterOpener = document.getElementById("filterOpener");
  const filterOpening = document.getElementById("filterOpening");
  const filterCloser = document.getElementById("filterCloser");
  const notScroll = document.querySelector("body");

  if (!filterOpener || !filterOpening || !filterCloser) return;

  filterOpener.addEventListener("click", () => {
    filterOpening.classList.replace(
      "[clip-path:polygon(0%_0%_,_100%_0%,_100%_0%,_0%_0%)]",
      "[clip-path:polygon(0%_0%_,_100%_0%,_100%_100%,_0%_100%)]"
    );
    notScroll.classList.add("overflow-hidden");
  });

  filterCloser.addEventListener("click", () => {
    filterOpening.classList.replace(
      "[clip-path:polygon(0%_0%_,_100%_0%,_100%_100%,_0%_100%)]",
      "[clip-path:polygon(0%_0%_,_100%_0%,_100%_0%,_0%_0%)]"
    );
    notScroll.classList.remove("overflow-hidden");
  });
}

filterOpening();

function customizeForm() {
  const customizeOpener = document.querySelectorAll(".customizeOpener");
  const customizeOpening = document.getElementById("customizeOpening");
  const customizeCloser = document.getElementById("customizeCloser");
  const notScroll = document.querySelector("body");
  const webUrl = window.location.href;

  if (!customizeOpener || !customizeOpening || !customizeCloser) return;

  customizeOpener.forEach((element) => {
    element.addEventListener("click", (event) => {
      if (event.target.href == webUrl + "#") {
        event.preventDefault();
      }
      customizeOpening.classList.replace("invisible", "visible");
      customizeOpening.classList.replace("h-0", "h-screen");
      customizeOpening.classList.replace("opacity-0", "opacity-1");
      notScroll.classList.add("overflow-hidden");
    });
  });

  customizeCloser.addEventListener("click", () => {
    customizeOpening.classList.replace("visible", "invisible");
    customizeOpening.classList.replace("h-screen", "h-0");
    customizeOpening.classList.replace("opacity-1", "opacity-0");
    notScroll.classList.remove("overflow-hidden");
  });

  if (
    customizeOpening.addEventListener("click", (el) => {
      if (el.target !== customizeOpening) return;
      customizeOpening.classList.replace("visible", "invisible");
      customizeOpening.classList.replace("h-screen", "h-0");
      customizeOpening.classList.replace("opacity-1", "opacity-0");
      notScroll.classList.remove("overflow-hidden");
    })
  );
}

customizeForm();
